import React, { useState } from "react";
import "./CareersPage.css";
import { Link } from "react-router-dom";

const CareersPage = () => {
  const [selectedJob, setSelectedJob] = useState(null);

  const jobs = [
    {
      id: 1,
      title: "Facility & Logistics Manager",
      type: "Full Time",
      location: "Lakowe, Sangotedo",
      salary: "₦80,000",
      description:
        "Oversee daily facility operations and logistics. Responsibilities include managing office assets, coordinating deliveries, supervising vendors, and ensuring smooth day-to-day operations. Candidate must be detail-oriented, organized, and capable of handling multiple tasks efficiently.",
    },
    {
      id: 2,
      title: "Social Media Manager",
      type: "Full Time",
      location: "Ikota Shopping Complex, VGC",
      salary: "₦200,000 - ₦250,000",
      description:
        "Plan, create, and manage social media content. Develop engaging campaigns to increase brand awareness, highlight services, and grow community engagement across all platforms. Candidate should have proven experience in growing social media platforms and analyzing digital performance.",
    },
    {
      id: 3,
      title: "Digital Marketing Executive",
      type: "Full Time",
      location: "Ikota Shopping Complex, VGC",
      salary: "₦200,000 - ₦250,000",
      description:
        "Execute and optimize digital marketing campaigns to attract and retain clients. Tasks include SEO, online ads, email campaigns, and ensuring strong brand visibility across company's digital platforms. The ideal candidate should have hands-on experience with digital tools, campaign tracking, and delivering measurable results.",
    },
    {
      id: 4,
      title: "Growth Executive",
      type: "Full Time",
      location: "Ikota Shopping Complex, VGC",
      salary: "₦150,000 - ₦250,000",
      description:
        "Identify business opportunities, attract new clients, and maintain strong customer relationships. The Growth Executive will present our investment and loan solutions to prospects, achieve sales targets, and collaborate with the marketing team to support business expansion. Strong communication and negotiation skills are required.",
    },
    {
      id: 5,
      title: "Creative Writer",
      type: "Full Time",
      location: "Ikota Shopping Complex, VGC",
      salary: "₦150,000",
      description:
        "Develop original written content including articles, blogs, marketing copy, and creative storytelling pieces. The Creative Writer will work closely with the marketing and communications team to ensure high-quality, engaging, and brand-consistent content. Candidate should possess strong writing skills, creativity, and the ability to adapt tone and style for different audiences.",
    },
  ];

  const showJobDetails = (job) => setSelectedJob(job);
  const closeJobDetails = () => setSelectedJob(null);

  return (
    <div className="rs-careers-page">
      <div className="rs-careers-hero">
        <div className="rs-careers-hero-content">
          <div className="rs-careers-hero-text">
            <h1 className="rs-careers-hero-title">
              Life at{" "}
              <span className="rs-careers-brand">RESPECTED SOLUTIONS</span>
            </h1>

            <div className="rs-careers-hero-description">
              <p>
                RESPECTED SOLUTIONS offers professional opportunities for career
                growth and advancement in personal skill set and ambitions. As a
                leading financial services company specializing in
                collateral-based lending in Nigeria, we take pride in being the
                employer of choice for fresh graduates and experienced hires in
                various fields within the purview of our operations.
              </p>

              <p>
                Every candidate is given equal opportunity without any
                discrimination, nepotism or favoritism as our selection process
                is merit-driven. Our training cuts across professional
                development, personal development, entrepreneurship and
                leadership for career growth. We are committed to cultivating
                and maintaining an innovation-driven environment ideal for young
                professionals. Our work environment allows employees to think
                outside the box, and bring their imagination to reality.
              </p>

              <p>
                Great opportunities await you in RESPECTED SOLUTIONS if you are:
                Creative and possess analytical skills, a team player with an
                exemplary attitude, self- motivated, result-oriented and a
                problem solver. These and more are what we look for in our
                prospective employees. We seek innovative individuals whose
                values align with RESPECTED SOLUTIONS's core values of
                excellence.
              </p>
            </div>
          </div>

          <div className="rs-careers-hero-image">
            <div className="rs-careers-image-placeholder">
              <div className="rs-careers-office-scene">
                <div className="rs-careers-person-silhouette"></div>
                <div className="rs-careers-desk"></div>
                <div className="rs-careers-window"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="rs-careers-ethics">
        <div className="rs-careers-container">
          <h2 className="rs-careers-section-title">
            Our Work <span className="rs-careers-highlight">Ethics</span>
          </h2>

          <p className="rs-careers-ethics-text">
            RESPECTED SOLUTIONS prides herself on the strong work ethics of her
            staff who are diligent, reliable, hardworking and committed to the
            continuous growth and success of the organisation. We value the
            well-being of our staff and we encourage them to strike a balance
            between their work and personal lives, thereby creating a healthy
            atmosphere for personal development and career growth.
          </p>
        </div>
      </div>

      <div className="rs-careers-openings">
        <div className="rs-careers-container">
          <h2 className="rs-careers-section-title">
            Available <span className="rs-careers-highlight">Openings</span>
          </h2>

          <div className="rs-careers-jobs-grid">
            {jobs.map((job) => (
              <div key={job.id} className="rs-careers-job-card">
                <h3 className="rs-careers-job-title">{job.title}</h3>

                <div className="rs-careers-job-details">
                  <span className="rs-careers-job-detail">
                    <strong>Job Type:</strong> {job.type}
                  </span>
                  <span className="rs-careers-job-detail">
                    <strong>Location:</strong> {job.location}
                  </span>
                  <span className="rs-careers-job-detail">
                    <strong>Salary:</strong> {job.salary}
                  </span>
                </div>

                <div className="rs-careers-job-actions">
                  <button
                    className="rs-careers-btn rs-careers-btn-details"
                    onClick={() => showJobDetails(job)}
                  >
                    Show More Details
                  </button>
                  <Link
                    to="mailto: idris.dolapo@respectedsolution.co"
                    className="rs-careers-btn rs-careers-btn-apply"
                  >
                    Apply for Role
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {selectedJob && (
        <div className="rs-careers-modal-overlay" onClick={closeJobDetails}>
          <div
            className="rs-careers-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="rs-careers-modal-header">
              <h3 className="rs-careers-modal-title">{selectedJob.title}</h3>
              <button
                className="rs-careers-modal-close"
                onClick={closeJobDetails}
              >
                ×
              </button>
            </div>

            <div className="rs-careers-modal-content">
              <div className="rs-careers-modal-details">
                <p>
                  <strong>Job Type:</strong> {selectedJob.type}
                </p>
                <p>
                  <strong>Location:</strong> {selectedJob.location}
                </p>
                <p>
                  <strong>Salary:</strong> {selectedJob.salary}
                </p>
              </div>

              <div className="rs-careers-modal-description">
                <h4>Job Description</h4>
                <p>{selectedJob.description}</p>
              </div>

              <div className="rs-careers-modal-actions">
                <Link
                  to="/contact-us"
                  className="rs-careers-btn rs-careers-btn-apply"
                >
                  Apply via Website
                </Link>

                <a
                  href="mailto:idris.dolapo@respectedsolution.co"
                  className="rs-careers-btn rs-careers-btn-apply"
                >
                  Apply via Email
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CareersPage;
